"use client";
import React, { useEffect, useState } from "react";
import { IoIosArrowForward } from "react-icons/io";
import SectionHeading from "../shared/SectionHeading";

const FrequentlyAskedQ = ({ data }) => {
  // State to track the selected question and answer
  const [sectionNumber, setSectionNumber] = useState();
  const [selectedQA, setSelectedQA] = useState({ que: "", ans: "" });
  const [isActive, setIsActive] = useState(null);

  // Function to handle the question click
  const handleQuestionClick = (item, index) => {
    if (isActive === index) {
      // If clicking the same question, close it
      setIsActive(null);
      setSelectedQA({ que: "", ans: "" });
    } else {
      // If clicking a different question, open it
      setSelectedQA(item);
      setIsActive(index);
    }
  };

  // Set the initial section number only
  useEffect(() => {
    if (data.section[12].title === "Frequently Asked Questions") {
      setSectionNumber(12);
    } else if (data.section[13].title === "Frequently Asked Questions") {
      setSectionNumber(13);
    } else if (data.section[14].title === "Frequently Asked Questions") {
      setSectionNumber(14);
    }
  }, [data.section]);

  if (!data.section[sectionNumber]) {
    return <div />;
  }

  return (
    <div className="py-12">
      <div className="container mx-auto px-4 lg:px-8">
        {/* Section Heading */}
        <div className="text-center mb-10">
          <h2 className="text-3xl md:text-4xl font-medium">
            <span className="text-primary-color">Frequently Asked</span>{" "}
            <span className="text-secondary-color">Questions</span>
          </h2>
          <p className="mt-3 text-gray-600 text-base md:text-lg">
            Find answers to the most common queries below.
          </p>
        </div>

        {/* FAQ Section */}
        <div className="max-w-3xl mx-auto">
          {data.section[sectionNumber].list1.map((item, index) => (
            <div key={index} className="mb-3">
              <div
                className={`bg-[#c9dbff73] rounded-lg shadow-sm transition-all duration-300 ${
                  isActive === index ? 'shadow-md' : 'hover:shadow-md'
                }`}
                onClick={() => handleQuestionClick(item, index)}
              >
                <div className="flex justify-between items-center p-4 cursor-pointer">
                  <h3 className={`text-base md:text-lg font-medium ${
                    isActive === index ? 'text-primary-color' : 'text-gray-800'
                  }`}>
                    {item.que}
                  </h3>
                  <IoIosArrowForward
                    className={`text-xl transition-transform duration-300 transform ${
                      isActive === index ? "rotate-90 text-primary-color" : "rotate-0"
                    }`}
                  />
                </div>
                
                {isActive === index && (
                  <div className="px-4 pb-4 bg-[#ffffff]">
                    <div className=" pt-4">
                      <div className="prose prose-gray max-w-none">
                        {item.ans.split('\n').map((paragraph, pIndex) => (
                          <p key={pIndex} className="text-gray-600 text-sm md:text-base leading-relaxed mb-3 last:mb-0">
                            {paragraph}
                          </p>
                        ))}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FrequentlyAskedQ;
